import { useCallback, useEffect, useState } from 'react';
import { fetchWallet, type WalletSummary } from './creditPacks.api';

/** Wallet header data. Failure leaves `wallet` null — the header simply doesn't render. */
export function useWallet() {
  const [wallet, setWallet] = useState<WalletSummary | null>(null);
  const reload = useCallback(async () => {
    try {
      setWallet(await fetchWallet());
    } catch {
      setWallet(null);
    }
  }, []);
  useEffect(() => {
    let mounted = true;
    fetchWallet()
      .then((data) => {
        if (mounted) setWallet(data);
      })
      .catch(() => {
        if (mounted) setWallet(null);
      });
    return () => {
      mounted = false;
    };
  }, []);
  return { wallet, reload };
}
